export default __webpack_public_path__ + "static/media/basware.0c423462.png";